module.exports = __webpack_public_path__ + "static/media/accent_on.54635a26.svg";